import ModuleUnavailablePage from "../../../../components/Admin/InvestorPortal/ModuleUnavailablePage";
import { withInvestorPortalGuard } from "../withInvestorPortalGuard";

function InvestorAccountsListPage() {
  return <ModuleUnavailablePage moduleName="Investor accounts" />;
}

export default withInvestorPortalGuard(InvestorAccountsListPage, "investorPortal");
